import { brandPrimaryHover, titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	advancedSearchButton: {
		alignItems: 'center',
		color: brandPrimaryHover,
		display: 'flex',
		fontSize: 14,
		margin: 'auto',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	alertsBody: {
		display: 'flex',
		justifyContent: 'center',
		overflow: 'hidden',
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	container: {
		textAlign: 'center',
	},
	recommendedTagsBody: {
		display: 'flex',
		justifyContent: 'center',
		overflow: 'hidden',
	},
	section: {
		':not(:first-child)': {
			marginTop: 70,
		},
	},
	sectionTitle: {
		color: titles,
		fontSize: 16,
		marginBottom: 20,
	},
	tag: {
		cursor: 'pointer',
		marginLeft: 20,
		marginTop: 20,
	},
	tagsContainer: {
		marginLeft: -20,
		marginTop: -20,
		width: '80%',
	},
});
